import { render, staticRenderFns } from "./modal-order-issue.vue?vue&type=template&id=5e3acc6f&scoped=true"
import script from "./modal-order-issue.vue?vue&type=script&lang=js"
export * from "./modal-order-issue.vue?vue&type=script&lang=js"
import style0 from "./modal-order-issue.vue?vue&type=style&index=0&id=5e3acc6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3acc6f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseAlert.vue').default,BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
